import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Collapse, ListItemButton } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import UseIconHooks from '../hooks/useIconHooks';
import UseCustomState from '../hooks/useCustomState';
import { Link, NavLink } from 'react-router-dom';
import LabelRegistro from '../components/common/labels/labelRegistro';
import InboxIcon from '@mui/icons-material/Inbox';
import {
  toolbarDrawerMenu,
  labelRegistroDrawerMenu,
  listItemDrawerMenu,
  linkDrawerMenu,
  listDrawerMenu,
} from '../global/styles';
import colors from '../../config/colors';
import { ConfigurationContext } from '../context/configurationContext';
import { useSelector } from 'react-redux';

const Menu = ({ handleDrawerToggle, mobileOpen, drawerWidth, window, regimen }) => {
  const { menu } = useContext(ConfigurationContext);
  const isUltra = useSelector((state) => state.afiliado.infoAfiliado.isUltra);
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = isUltra && ultraDarkMode;
  const isUltraLight = isUltra && !ultraDarkMode;
  menu.forEach((item) => (item.childEvent = UseCustomState(false)));

  const iconColor = isDark ? colors.ultraAccentLight : isUltraLight ? colors.ulAccent : colors.primary;
  const textColor = isDark ? colors.ultraSilver : isUltraLight ? colors.ulText : 'black';
  const drawerBg = isDark ? colors.ultraDark : isUltraLight ? colors.ulCard : undefined;

  const drawer = (
    <div style={{ backgroundColor: drawerBg, minHeight: '100vh', transition: 'background-color 0.45s ease' }}>
      <Toolbar style={{ ...toolbarDrawerMenu }}>
        <LabelRegistro style={{ ...labelRegistroDrawerMenu }} isUltra={isUltra} />
      </Toolbar>

      <List style={{ paddingLeft: 6, fontFamily: 'Montserrat' }}>
        {menu !== undefined && menu !== null
          ? menu.map((item) => (
              <div key={item.codigo} id={`menu-${item.descripcion.replace(' ', '-')}`}>
                {item.hasChild ? (
                  <ListItem button style={{ ...listItemDrawerMenu }} onClick={item.childEvent.toggle}>
                    <ListItemIcon style={{ paddingLeft: 22, color: iconColor }}>{item.icono}</ListItemIcon>
                    <ListItemText primary={item.descripcion} primaryTypographyProps={{ style: { color: textColor } }} />
                    {item.childEvent.value
                      ? UseIconHooks('expandedl', { onClick: item.childEvent.toggle, style: { color: textColor } })
                      : UseIconHooks('expandedm', { onClick: item.childEvent.toggle, style: { color: textColor } })}
                  </ListItem>
                ) : item.isExterna === true ? (
                  <a href={item.url} style={{ ...linkDrawerMenu, color: textColor }} target='_blank'>
                    <ListItem button style={{ ...listItemDrawerMenu }}>
                      <ListItemIcon style={{ paddingLeft: 22, color: iconColor }}>{item.icono}</ListItemIcon>
                      <ListItemText primary={item.descripcion} primaryTypographyProps={{ style: { color: textColor } }} />
                    </ListItem>
                  </a>
                ) : item.descripcion !== 'Club de Beneficios' ? (
                  <Link to={item.url} style={{ ...linkDrawerMenu, color: textColor }}>
                    <ListItem button style={{ ...listItemDrawerMenu }}>
                      <ListItemIcon style={{ paddingLeft: 22, color: iconColor }}>{item.icono}</ListItemIcon>
                      <ListItemText primary={item.descripcion} primaryTypographyProps={{ style: { color: textColor } }} />
                    </ListItem>
                  </Link>
                ) : regimen === 'CONTRIBUTIVO' || regimen === 'SeNaSa LARIMAR' || regimen === 'SUBSIDIADO' ? (
                  <Link to={'/club'} target='_blank' style={{ ...linkDrawerMenu, color: textColor }}>
                    <ListItem button style={{ ...listItemDrawerMenu }}>
                      <ListItemIcon style={{ paddingLeft: 22, color: iconColor }}>{item.icono}</ListItemIcon>
                      <ListItemText primary={item.descripcion} primaryTypographyProps={{ style: { color: textColor } }} />
                    </ListItem>
                  </Link>
                ) : null}
                {item.childEvent.value ? (
                  <Collapse in={item.childEvent.value} timeout='auto' style={{ paddingLeft: 10 }}>
                    <List component='div' disablePadding style={{ ...listDrawerMenu }}>
                      {item.children.map((child) => (
                        <NavLink key={child.codigo} to={child.url} style={{ ...linkDrawerMenu, color: textColor }}>
                          <ListItem button style={{ ...listItemDrawerMenu }}>
                            <ListItemIcon style={{ paddingLeft: 22, color: iconColor }}>
                              {child.icono}
                            </ListItemIcon>
                            <ListItemText primary={child.descripcion} primaryTypographyProps={{ style: { color: textColor } }} />
                          </ListItem>
                        </NavLink>
                      ))}
                    </List>
                  </Collapse>
                ) : null}
              </div>
            ))
          : null}
      </List>
    </div>
  );

  const drawerSx = isDark
    ? { backgroundColor: colors.ultraDark }
    : isUltraLight
      ? { backgroundColor: colors.ulCard, borderRight: `1px solid ${colors.ulBorder}` }
      : {};

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box
      component='nav'
      sx={{
        width: { sm: drawerWidth },
        flexShrink: { sm: 0 },
      }}
      aria-label='mailbox folders'
    >
      <Drawer
        container={container}
        variant='temporary'
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, ...drawerSx, transition: 'background-color 0.45s ease' },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant='permanent'
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, ...drawerSx, transition: 'background-color 0.45s ease' },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Menu;
